import { IS_LOCAL, IS_PROD, IS_STAGE, IS_TEST, LOCAL_API, PROD_API, TEST_API } from "../config"

export const setEnv = ({ hostname }: { hostname: string }) => {
  if (hostname === "localhost") {
    return "local"
  }

  if (hostname === "fms-test.noa.one") {
    return "testing"
  }

  if (hostname === "fms-staging.noa.one") {
    return "staging"
  }

  if (hostname === "fms.noa.one") {
    return "production"
  }

  return "production"
}

export const setApiUrl = () => {
  if (IS_LOCAL) {
    return LOCAL_API
  }

  if (IS_TEST) {
    return TEST_API
  }

  if (IS_PROD || IS_STAGE) {
    return PROD_API
  }

  return PROD_API
}
